/**
 * The viewer holds neither `access:admin_mode` nor `access:teacher_mode`, so
 * there is no workspace to send them to.
 *
 * Two ways to arrive here, and the copy has to serve both. The common one is a
 * STALE TOKEN: a tab open across the deploy that added these scopes holds a
 * token minted before they existed, and signing in again mints one with them.
 * The other is an account nobody has granted a role, which needs an
 * administrator.
 *
 * Its own page rather than `UnauthorizedPage` because that one offers "Return
 * to home", and home is what sent them here — the viewer would loop. Signing
 * out is the action that actually resolves the common case, so it is the one
 * on the page.
 */
import { useAuth0 } from '@auth0/auth0-react';

export default function NoWorkspacePage() {
  const { logout } = useAuth0();

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center max-w-md px-6">
        <h1 className="text-3xl font-bold text-bark-900 dark:text-stone-100 mb-4">
          No workspace available
        </h1>
        <p className="text-stone-600 dark:text-stone-400 mb-6">
          Your sign-in doesn&rsquo;t grant access to either the admin or the teacher view. If you
          were using Nebari before today, signing in again will usually fix it — otherwise ask an
          administrator to check your role.
        </p>
        <button
          type="button"
          onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
          className="text-moss-600 hover:text-moss-700 text-sm underline"
        >
          Sign out and sign in again
        </button>
      </div>
    </div>
  );
}
